import {v4 as uuidv4} from "uuid";

export class Ticket {
  constructor(
    public ticketCategory: string,
    public mark: string,
    public token = uuidv4(),
    public sold = false,
    public active = true,
    public used = false,
  ) {
  }

}
